// @flow
import React from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

type Props = {
  className?: string,
  communityLabel?: string,
  ratingImage?: ?{
    alt: string,
    src: string,
  },
  seasonLink: ?{
    iconName?: IconName,
    label: string,
    url: string,
  },
};

export function ProductIntroductionActions(props: Props) {
  const { className, communityLabel, ratingImage = {}, seasonLink = {} } = props;

  return (
    <div
      className={classnames(
        className,
        'flex flex-col sm:flex-row items-center sm:items-stretch sm:-mx-2',
      )}
    >
      {ratingImage &&
        ratingImage.src && (
          <TrackClick
            as={DynamicLink}
            trackingData={{
              categoryGA: 'resort',
              actionGA: 'practicalInfos',
              labelGA: 'tripAdvisorAnchor',
            }}
            className="reset-anchor mx-2 border-1 border-solid leading-none p-2 rounded-tiny"
            url="#tripadvisor"
          >
            <Image
              altMsg={ratingImage.alt}
              className=""
              dontChangeAnything
              imageUrl={ratingImage.src}
            />
          </TrackClick>
        )}
      {communityLabel && (
        <TrackClick
          as={DynamicLink}
          trackingData={{
            categoryGA: 'resort',
            actionGA: 'wibilong',
            labelGA: 'seeQuestionsAndAnswers',
          }}
          className="bg-turquoise border-1 border-turquoise inline-flex items-center justify-center leading-one mx-2 mt-5 sm:mt-0 px-4 py-3 sm:py-2 rounded-tiny text-base text-white"
          url="#wibilong"
        >
          <Icon className="rtl:mr-1" name={ICONS.COMMUNITY} />
          {communityLabel}
        </TrackClick>
      )}
      {seasonLink &&
        seasonLink.url && (
          <DynamicLink
            className="border-1 border-gray-light hover:border-turquoise font-bold inline-flex items-center justify-center leading-one mx-2 mt-5 sm:mt-0 px-4 py-3 sm:py-2 rounded-tiny text-base text-gray-darker hover:text-turquoise transition-colors"
            url={seasonLink.url}
          >
            <Icon className="rtl:mr-1" name={seasonLink.iconName} />
            {seasonLink.label}
          </DynamicLink>
        )}
    </div>
  );
}
